import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { Fill } from '@atlassian/jira-common-components-skeleton/src/fill.tsx';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';
import { FieldCategoryTitle, GrowingScrollableSection } from '../styled.tsx';

export const LoadingState = () => (
	<GrowingScrollableSection>
		<FieldCategoryTitle>
			<Fill />
		</FieldCategoryTitle>
		<Field />
		<Field />
		<Field />
		<Field />
		<Field />
	</GrowingScrollableSection>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Field = styled(Skeleton)({
	width: '100%',
	height: '42px',
	marginBottom: token('space.050'),
});
